
const setJwt = token => {
 
    localStorage.setItem("access_token", token);
}

const getJwt = () => {
    const token = localStorage.getItem("access_token");
    if(token !== null && token !== undefined) {
        return token;
    } else {
        return null;
    }
}

const removeJWT = () => {
    localStorage.removeItem("access_token");
}

function parseJwt(token) {
  
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');

        const jsonPayload = decodeURIComponent(
            window.atob(padded).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join('')
        );

        return JSON.parse(jsonPayload);
    } catch (error) {
        console.error("Invalid token format:", error);
        return null;
    }
}

// const isValidToken = () => {
//     const token = getJwt(); // You must define or import this function
//     if (!token) {
//         return false;
//     }
    

//     const parsedJWT = parseJwt(token);

//     if (!parsedJWT || !parsedJWT.exp) {
//         return false;
//     }

//     const expiryTime = parsedJWT.exp * 1000; // Convert to milliseconds
//     const currentTime = Date.now(); // Current time in milliseconds
//     if(currentTime > expiryTime){
//        removeJWT()
//     }
//     return currentTime < expiryTime
   
// };
const isValidToken = () => {
    const token = getJwt(); // Assume this retrieves the token from localStorage or cookies
  
    if (!token) return false;
  
    const parsedJWT = parseJwt(token); // Assume this decodes base64 JWT
  
    if (!parsedJWT || !parsedJWT.exp) return false;
  
    const expiryTime = parsedJWT.exp * 1000; // JWT 'exp' is in seconds, convert to milliseconds
    const currentTime = Date.now();
  console.log ("parsedJWT",parsedJWT ,expiryTime ,currentTime );
    if (currentTime >= expiryTime) {
      removeJWT(); // Clear token if expired
      return false;
    }
  
    return true; // Valid and not expired
  };
  

export default {
    setJwt,
    getJwt,
    removeJWT,
    isValidToken
}